export default "__VITE_ASSET__65QpXsSt__"